export default "__VITE_ASSET__CTrOa69h__"